/**
 * This file contains the code for creating or editing the quiz
 */

import React from "react";
import QuizeThemeFirst from "../templates/theme_1";
import QuizeThemeSecond from "../templates/theme_2";
import {quiztypeenum} from "../enums/quiztypeenum";

import * as DOMPurify from "dompurify";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
  WhatsappShareButton,
  WhatsappIcon,
  EmailShareButton,
  EmailIcon,
} from "react-share";


var shareBtnSize = 36;
var shareUrl = "";

export class QuizPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabnum: this.props.tabnum,
      quiz: this.props.quiz,
      queformActive: this.props.queformActive,
      que: this.props.que,
      selectedQue: this.props.selectedQue,
      user: this.props.user,
      abc: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      tabnum: nextProps.tabnum,
      quiz: nextProps.quiz,
      queformActive: nextProps.queformActive,
      que: nextProps.que,
      selectedQue: nextProps.selectedQue,
      showEemailPreviewImg: this.props.quiz.collectuseremailflag,
      user: nextProps.user,
    });
  }

  showImages(jsonansimg) {
    if (jsonansimg != null) {
      var imgs = null;
      imgs = JSON.parse(jsonansimg);
      if (imgs.length != 0) {
        imgs.map((i_url, index) => {
          //    return <img key={index} className="quz-ans-img" src={i_url} />
          return <img className="quz-ans-img" key={index} src={"localhost/"} />;
        });
      }
    }
  }

  showAns(que) {
    var content = "";
    //var que = this.state.selectedQuePreview || this.state.que;
    //var que = this.state.que;

    var tempquetype = que == null ? "MCSA" : que.quetype;
    var jsonans = null;
    var jsonansimg = null;

    if (que != null) {
      jsonans = que.jsonans;
      jsonansimg = que.jsonansimg;
    }
    var ans = null;
    var anscount = 0;
    if (jsonans != null) {
      ans = JSON.parse(jsonans);
      anscount = ans.length;
    }

    var img = null;
    if (jsonansimg != null) {
      img = JSON.parse(jsonansimg);
    }

    if (ans == null || ans.length == 0) {
      ans = [];
      ans[0] = ans[1] = "";
    }
    if (tempquetype == "TF") {
      ans[0] = true.toString().toUpperCase();
      ans[1] = false.toString().toUpperCase();
    }
    // for theme colors select
    var button_color = { hex: "" };
    var button_color_text = { hex: "" };
    var header_text = { hex: "" };
    var header_bg = { hex: "" };
    if (
      this.state.quiz.theme_color != null &&
      this.state.quiz.theme_color != ""
    ) {
      let theme_colors = JSON.parse(this.state.quiz.theme_color);
      button_color.hex = theme_colors[6].button_color;
      button_color_text.hex = theme_colors[7]
        ? theme_colors[7].button_color_text
        : "";
      header_text.hex = theme_colors[1].header_text;
      header_bg.hex = theme_colors[0].header_bg;
    }
    content = (
      <div className="col-md-12">
        {ans.map((element, index) => {
          if (element != null) {
            // var backgroundurl = ((this.state.selectedQue == null || this.state.selectedQue.queimg == null || this.state.selectedQue.queimg == "") ? null : "url('" + this.props.basepath + this.state.selectedQue.queimg + "') no-repeat center");
            var backgroundurl =
              img == null || img[index] == null || img[index] == ""
                ? null
                : "url('" + img[index] + "') no-repeat center";
            if (Array.isArray(img) && img.length != 0) {
              return (
                <div className="col-md-4 m-t-sm" key={index}>
                  <div id={`divans${index}`} className="">
                    {backgroundurl != null ? (
                      <div
                        className="upload-image"
                        style={{
                          background: backgroundurl,
                          margin: 0,
                          height: 121,
                          backgroundSize: "cover",
                        }}
                      ></div>
                    ) : null}
                    <div
                      style={{
                        width: 100 + "%",
                        whiteSpace: "normal",
                        cursor: "unset",
                      }}
                      className={
                        backgroundurl == null
                          ? "quizpreview btn y"
                          : "quizpreview"
                      }
                      ref={(el) => {
                        if (el) {
                          el.style.setProperty(
                            "background-color",
                            button_color ? button_color.hex : "",
                            "important"
                          );
                          el.style.setProperty(
                            "color",
                            button_color_text && button_color_text.hex
                              ? button_color_text.hex
                              : this.state.quiz &&
                                this.state.quiz.welcome_message_color
                              ? this.state.quiz.welcome_message_color
                              : "",
                            "important"
                          );
                        }
                      }}
                    >
                      {backgroundurl != null && backgroundurl != ""
                        ? decodeURIComponent(element)
                        : element != "" && element != null
                        ? decodeURIComponent(element)
                        : "Ans " + (index + 1)}
                    </div>
                  </div>
                </div>
              );
            } else {
              return (
                <div
                  className="col-md-offset-2 col-md-8 m-t-sm col-md-offset-2"
                  key={index}
                >
                  <div id={`divans${index}`} className="">
                    {backgroundurl != null ? (
                      <div
                        className="upload-image"
                        style={{
                          background: backgroundurl,
                          margin: 0,
                          height: 121,
                          backgroundSize: "cover",
                        }}
                      ></div>
                    ) : null}
                    <div
                      style={{
                        width: 100 + "%",
                        whiteSpace: "normal",
                        cursor: "unset",
                      }}
                      className={
                        backgroundurl == null
                          ? "quizpreview btn"
                          : "quizpreview"
                      }
                      ref={(el) => {
                        if (el) {
                          el.style.setProperty(
                            "background-color",
                            button_color ? button_color.hex : "",
                            "important"
                          );
                          el.style.setProperty(
                            "color",
                            button_color_text && button_color_text.hex
                              ? button_color_text.hex
                              : this.state.quiz &&
                                this.state.quiz.welcome_message_color
                              ? this.state.quiz.welcome_message_color
                              : "",
                            "important"
                          );
                        }
                      }}
                    >
                      {backgroundurl != null && backgroundurl != ""
                        ? decodeURIComponent(element)
                        : element != "" && element != null
                        ? decodeURIComponent(element)
                        : "Ans " + (index + 1)}
                    </div>
                  </div>
                </div>
              );
            }
          }
        })}
      </div>
    );
    return content;
  }

  renderQuizPreviewHeader() {
    // for theme colors select
    var header_bg = { hex: "" };
    var header_text = { hex: "" };
    if (
      this.state.quiz.theme_color != null &&
      this.state.quiz.theme_color != ""
    ) {
      let theme_colors = JSON.parse(this.state.quiz.theme_color);
      header_bg.hex = theme_colors[0].header_bg;
      header_text.hex = theme_colors[1].header_text;
    }
    return (
      <div
        className={`c panel-heading ${
          this.state.quiz == null || this.state.quiz.theme == null
            ? "theme1"
            : this.state.quiz.theme
        }`}
        ref={(el) => {
          if (el) {
            el.style.setProperty(
              "background",
              this.props.header_bg
                ? this.props.header_bg.hex
                : header_bg
                ? header_bg.hex
                : "",
              "important"
            );
            el.style.setProperty(
              "color",
              this.props.header_text
                ? this.props.header_text.hex
                : header_text
                ? header_text.hex
                : "",
              "important"
            );
          }
        }}
      >
        <div className="row">
          <div
            className="col-md-10 col-sm-10 col-xs-10"
            style={{ fontWeight: "bold", wordBreak: "break-word" }}
          >
            {this.state.quiz == null || this.state.quiz.title == ""
              ? "Enter Quiz Title"
              : this.state.quiz.title}
          </div>
          <div className="col-md-2 col-sm-2 col-xs-2">
            <img
              className="glyphicon img-responsive pull-right vcenter"
              src={this.state.quiz != null ? this.state.quiz.companylogo : ""}
              style={{ minWidth: 25, height: 25 }}
            />
          </div>
        </div>
      </div>
    );
  }

  renderQuizPreviewFooter() {
    // for theme colors select

    var footer_bg = { hex: "" };
    var footer_text_color = { hex: "" };
    if (
      this.state.quiz.theme_color != null &&
      this.state.quiz.theme_color != ""
    ) {
      let theme_colors = JSON.parse(this.state.quiz.theme_color);

      footer_bg.hex = theme_colors[0].footer_bg;
      footer_text_color.hex = theme_colors[1].footer_text_color;
    }
    var content = (
      <div
        className="panel-footer"
        ref={(el) => {
          if (el) {
            el.style.setProperty(
              "background",
              this.props.footer_bg
                ? this.props.footer_bg.hex
                : footer_bg
                ? footer_bg.hex
                : "",
              "important"
            );
          }
        }}
      >
        <a
          className="graded-footer"
          href="test"
          id="btnqzcreate"
          ref={(el) => {
            if (el) {
              el.style.setProperty(
                "color",
                this.props.footer_text_color
                  ? this.props.footer_text_color.hex
                  : footer_text_color
                  ? footer_text_color.hex
                  : "",
                "important"
              );
            }
          }}
        >
          Create Your Free Quiz
        </a>
        <a
          className="pull-right graded-footer"
          id="qzfooter"
          style={{ paddingTop: 3 }}
          ref={(el) => {
            if (el) {
              el.style.setProperty(
                "color",
                this.props.footer_text_color
                  ? this.props.footer_text_color.hex
                  : footer_text_color
                  ? footer_text_color.hex
                  : "",
                "important"
              );
            }
          }}
        >
          {this.state.quiz != null &&
          this.state.quiz.quizfootermsg != null &&
          this.state.quiz.quizfootermsg != ""
            ? this.state.quiz.quizfootermsg
            : "Powered By Quizzes4Leads"}
        </a>
      </div>
    );

    if (this.state.user != null && this.state.user.mode == "paid") {
      content = (
        <div
          className="panel-footer"
          ref={(el) => {
            if (el) {
              el.style.setProperty(
                "background",
                this.props.footer_bg
                  ? this.props.footer_bg.hex
                  : footer_bg
                  ? footer_bg.hex
                  : "",
                "important"
              );
            }
          }}
        >
          <a
            className="graded-footer"
            href="test"
            id="btnqzcreate"
            ref={(el) => {
              if (el) {
                el.style.setProperty(
                  "color",
                  this.props.footer_text_color
                    ? this.props.footer_text_color.hex
                    : footer_text_color
                    ? footer_text_color.hex
                    : "",
                  "important"
                );
              }
            }}
          ></a>
          <a
            className="pull-right graded-footer"
            id="qzfooter"
            style={{ paddingTop: 3 }}
            ref={(el) => {
              if (el) {
                el.style.setProperty(
                  "color",
                  this.props.footer_text_color
                    ? this.props.footer_text_color.hex
                    : footer_text_color
                    ? footer_text_color.hex
                    : "",
                  "important"
                );
              }
            }}
          ></a>
        </div>
      );
    }

    return content;
  }

  render() {
    // for theme colors select
    var header_bg = { hex: "" };
    var header_text = { hex: "" };
    var header_content_bg = { hex: "" };
    var header_content_text = { hex: "" };
    var footer_bg = { hex: "" };
    var footer_text_color = { hex: "" };
    var button_color = { hex: "" };
    var button_color_text = { hex: "" };

    if (
      this.state.quiz.theme_color != null &&
      this.state.quiz.theme_color != ""
    ) {
      let theme_colors = JSON.parse(this.state.quiz.theme_color);
      header_bg.hex = theme_colors[0].header_bg;
      header_text.hex = theme_colors[1].header_text;
      header_content_bg.hex = theme_colors[2].header_content_bg;
      header_content_text.hex = this.state.quiz.welcome_message_color ? this.state.quiz.welcome_message_color :theme_colors[3].header_content_text;
      footer_bg.hex = theme_colors[4].footer_bg;
      footer_text_color.hex = theme_colors[5].footer_text_color;
      button_color.hex = theme_colors[6].button_color;
      button_color_text.hex = theme_colors[7].button_color_text
        ? theme_colors[7].button_color_text
        : this.state.quiz && this.state.quiz.welcome_message_color
        ? this.state.quiz.welcome_message_color
        : "";
    }
    
    var content = null;
    var result = this.state.quiz.quizscoremsg;
    if(this.state.quiz.quiztype == quiztypeenum.graded_quiz && this.state.quiz.scoretype == 'Percentage'){
      result = "You performed remarkably well in this quiz and your score is 80%."
    }
    if(this.state.quiz && this.state.quiz.quiztype == quiztypeenum.personality_quiz && this.state.quiz.personalityArr && this.state.quiz.personalityArr.length>0){
      result = <div>Your personality is {this.state.quiz.personalityArr[0].title}.<br />{this.state.quiz.personalityArr[0].description}</div>
    }
    if(this.state.quiz && (this.state.quiz.quiztype == quiztypeenum.graded_quiz_with_personality || this.state.quiz.quiztype == quiztypeenum.weighted_graded_quiz)){
      var  jsonmetadata = this.state.quiz.quizmetadata;
      var quizmetadata = JSON.parse(jsonmetadata);
      if(quizmetadata && quizmetadata.length>0){
        result = <div>Your personality is {quizmetadata[0].title}.<br />{quizmetadata[0].description}</div>
      }
    }
    if(this.state.quiz && (this.state.quiz.quiztype == quiztypeenum.category_graded_quiz_with_personality)){
      var  jsonmetadata = this.state.quiz.quizmetadata;
      var quizmetadata = JSON.parse(jsonmetadata);
      var personalityArr = JSON.parse(quizmetadata.personalityArr);
      if(personalityArr && personalityArr.length>0){
        result = <div>Your personality is {personalityArr[0].title}.<br />{personalityArr[0].description}</div>;
      }
    }

    switch (parseInt(this.state.tabnum)) {
      //quizsetting page
      case 0:
        content = (
          <div
            className="panel-body a"
            id="quizcontent"
            ref={(el) => {
              if (el) {
                el.style.setProperty(
                  "background",
                  this.props.header_content_bg
                    ? this.props.header_content_bg.hex
                    : header_content_bg,
                  "important"
                );
              }
            }}
          >
            <div className="m-t-md qzwcmsg ql-editor">
              <div
                style={{
                  fontSize: "medium",
                  wordWrap: "break-word",
                  color: this.props.header_content_text.hex,
                }}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    this.state.quiz == null ||
                      this.state.quiz.quizwelcomemsg == ""
                      ? "Enter Welcome Message"
                      : this.state.quiz.quizwelcomemsg
                  ),
                }}
              ></div>
            </div>
            <button
              className="btn"
              id="previewbtnqzstart"
              ref={(el) => {
                if (el) {
                  el.style.setProperty(
                    "background",
                    this.props.button_color
                      ? this.props.button_color.hex
                      : button_color,
                    "important"
                  );
                  el.style.setProperty(
                    "color",
                    this.props.button_color_text &&
                      this.props.button_color_text.hex
                      ? this.props.button_color_text.hex
                      : this.state.quiz && this.state.quiz.welcome_message_color
                      ? this.state.quiz.welcome_message_color
                      : "",
                    "important"
                  );
                }
              }}
              style={{ marginTop: 10, width: 25 + "%", cursor: "unset" }}
              type="button"
            >
              {this.state.quiz.btn_start_text
                ? this.state.quiz.btn_start_text
                : "Start"}
            </button>
          </div>
        );
        {
          /* {this.renderQuizPreviewFooter()}
                            </div>
                        </div> */
        }
        break;
      //quetable
      case 1:
        if (this.state.queformActive) {
          // content = <div className="col-md-12" style={{backgroundSize: 'cover', backgroundImage: 'url(' + this.state.quiz.backgroundimg + ')'}}>
          //         <div className="Sign-In-Label" style={{marginTop:0,paddingTop:3,}}>Quiz Preview </div>
          //         <div className={`panel panel-blur animated slideIn ${this.state.quiz.theme}`}>
          //         {this.renderQuizPreviewHeader()}
          //<img className={(this.state.que==null || this.state.que.queimg==null || this.state.que.queimg=="")?"hide":""} src={(this.state.que== null || this.state.que.queimg==null)?"":this.state.que.queimg} style={{height:48,width:48}}/>
          var backgroundurl =
            this.state.selectedQue == null ||
            this.state.selectedQue.queimg == null ||
            this.state.selectedQue.queimg == ""
              ? null
              : "url('" + this.state.selectedQue.queimg + "') no-repeat center";
          content = (
            <div
              className="panel-body b"
              id="quizcontent"
              style={{
                backgroundColor: this.props.header_content_bg
                  ? this.props.header_content_bg.hex
                  : header_content_bg,
              }}
            >
              <div id="startForm" action="#" method="get">
                <div className="startcontainer col-md-12 col-sm-12 col-xs-12">
                  <label
                    className="control-label row-label"
                    id="lblque"
                    htmlFor="input-success"
                  ></label>
                  <div
                    className="text-center m-md qzwcmsg col-md-12 ql-editor"
                    style={{
                      fontSize: "medium",
                      wordWrap: "break-word",
                      paddingBottom: 40,
                    }}
                  >
                    {backgroundurl != null ? (
                      <div
                        className="col-md-8 col-md-offset-2"
                        style={{
                          background: backgroundurl,
                          backgroundSize: "contain",
                          height: 150,
                        }}
                      ></div>
                    ) : null}
                    <div
                      className="col-md-8 col-md-offset-2"
                      style={{ marginTop: 10 }}
                      ref={(el) => {
                        if (el) {
                          el.style.setProperty(
                            "color",
                            header_content_text ? header_content_text.hex : "",
                            "important"
                          );
                        }
                      }}
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          this.state.selectedQue == null
                            ? "Sample Question Title"
                            : this.state.selectedQue.title == null ||
                              this.state.selectedQue.title == ""
                            ? "Sample Question Title"
                            : this.state.selectedQue.title
                        ),
                      }}
                    ></div>
                  </div>
                  {this.showAns(this.state.selectedQue)}
                </div>
              </div>
            </div>
          );
        } else {
          var backgroundurl =
            this.state.selectedQue == null ||
            this.state.selectedQue.queimg == null ||
            this.state.selectedQue.queimg == ""
              ? null
              : "url('" + this.state.selectedQue.queimg + "') no-repeat center";

          content = (
            <div
              className="panel-body c"
              id="quizcontent"
              style={{
                backgroundColor: this.props.header_content_bg
                  ? this.props.header_content_bg.hex
                  : header_content_bg,
              }}
            >
              <div id="startForm" action="#" method="get">
                <div className="startcontainer col-md-12 col-sm-12 col-xs-12">
                  <label
                    className="control-label row-label"
                    id="lblque"
                    htmlFor="input-success"
                  ></label>
                  <div
                    className="text-center m-md qzwcmsg col-md-12"
                    style={{
                      fontSize: "medium",
                      wordWrap: "break-word",
                      paddingBottom: 40,
                    }}
                  >
                    {backgroundurl != null ? (
                      <div
                        className="col-md-8 col-md-offset-2"
                        style={{
                          background: backgroundurl,
                          backgroundSize: "contain",
                          height: 150,
                        }}
                      ></div>
                    ) : null}
                    <div
                      className="col-md-8 col-md-offset-2 Personality-text"
                      style={{
                        marginTop: 10,
                        color:
                          header_content_text && header_content_text.hex
                            ? header_content_text.hex
                            : this.state.quiz && this.state.quiz.welcome_message_color
                            ? this.state.quiz.welcome_message_color
                            : ""
                      }}
                      ref={(el) => {
                        if (el) {
                          el.style.setProperty(
                            "color",
                            header_content_text && header_content_text.hex
                              ? header_content_text.hex
                              : this.state.quiz &&
                                this.state.quiz.welcome_message_color
                              ? this.state.quiz.welcome_message_color
                              : "",
                            "important"
                          );
                        }
                      }}
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          this.state.selectedQue == null
                            ? "Question Title"
                            : this.state.selectedQue.title == null ||
                              this.state.selectedQue.title == ""
                            ? "Question Title"
                            : this.state.selectedQue.title
                        ),
                      }}
                    ></div>
                  </div>
                  {this.showAns(this.state.selectedQue)}
                </div>
              </div>
            </div>
          );
        }

        break;
      
      // leadgeneration
      case 2:
        content = (
          <div
            className="panel-body d"
            id="quizcontent"
            style={{
              backgroundColor: this.props.header_content_bg
                ? this.props.header_content_bg.hex
                : header_content_bg,
            }}
          >
            <div className="startcontainer col-md-10 col-sm-10 col-xs-10">
              <div
                className="m-t-sm qzwcmsg"
                style={{
                  fontSize: "medium",
                  wordWrap: "break-word",
                }}
                ref={(el) => {
                  if (el) {
                    el.style.setProperty(
                      "color",
                      header_content_text ? header_content_text.hex : "",
                      "important"
                    );
                  }
                }}
              >
                {this.state.quiz != null &&
                this.state.quiz.collectuseremailflag == "1"
                  ? this.state.quiz.quizemailmsg
                  : null}
              </div>
              <input type='text' className="form-control m-t-sm"
              placeholder="Name" value={this.state.quiz && this.state.quiz.enter_your_name_text}
              />
              <input type='text' className="form-control m-t-sm"
              placeholder="Email" value={this.state.quiz && this.state.quiz.enter_your_email_text}
              />
              {this.state.quiz && this.state.quiz.privacy_policy_text?<div class="quiz_wrap__content___text privacy-policy-text"><p>{this.state.quiz.privacy_policy_text}</p></div>:null}
              <a
                className="btn m-t-sm result-button"
                href={`http://${
                  this.state.quiz == null
                    ? "www.socialmbuzz.com"
                    : this.state.quiz.quizofferbtnlink
                }`}
                target="_blank"
                ref={(el) => {
                  if (el) {
                    el.style.setProperty(
                      "background-color",
                      button_color ? button_color.hex : "",
                      "important"
                    );
                    el.style.setProperty("border", "0", "important");
                    el.style.setProperty(
                      "color",
                      button_color_text ? button_color_text.hex : "",
                      "important"
                    );
                  }
                }}
              >

                {this.state.quiz == null ||
                this.state.quiz.continue_button_text == null ||
                this.state.quiz.continue_button_text == ""
                  ? "Check Your Score"
                  : this.state.quiz.continue_button_text}
              </a>

              <div
                className="m-t-md qzwcmsg"
                style={{
                  fontSize: "medium",
                  wordWrap: "break-word",
                }}
              >
                {this.state.quiz == null
                  ? "Sample Thank You Message"
                  : this.state.quiz.quizthankyoumsg}{" "}
              </div>
              <br />
            </div>
          </div>
        );

        break;
      
      // landing page  
      case 3:

        content = (
          <div
            className="panel-body d"
            id="quizcontent"
            style={{
              backgroundColor: this.props.header_content_bg
                ? this.props.header_content_bg.hex
                : header_content_bg,
            }}
          >
            <div className="startcontainer col-md-10 col-sm-10 col-xs-10">
              <div
                className="m-t-sm qzwcmsg"
                style={{
                  fontSize: "medium",
                  wordWrap: "break-word",
                }}
                ref={(el) => {
                  if (el) {
                    el.style.setProperty(
                      "color",
                      header_content_text ? header_content_text.hex : "",
                      "important"
                    );
                  }
                }}
              >
                {this.state.quiz != null &&
                this.state.quiz.collectuseremailflag == "1"
                  ? this.state.quiz.quizemailmsg
                  : null}
              </div>
              <div className='col-md-12 m-t-md' style={{ color:header_content_text ? header_content_text.hex : ''}}>{this.state.quiz? this.state.quiz.this_is_certificate_is_text:null}</div>
              <div className='col-md-12 m-t-md' style={{ color:header_content_text ? header_content_text.hex : ''}}>{result}</div>
              
              <div
                className="m-t-md qzwcmsg"
                style={{
                  fontSize: "medium",
                  wordWrap: "break-word",
                }}
                ref={(el) => {
                  if (el) {
                    el.style.setProperty(
                      "color",
                      header_content_text && header_content_text.hex
                        ? header_content_text.hex
                        : this.state.quiz &&
                          this.state.quiz.welcome_message_color
                        ? this.state.quiz.welcome_message_color
                        : "",
                      "important"
                    );
                  }
                }}
              >
                {this.state.quiz == null || this.state.quiz.quizoffermsg == ""
                  ? "Schedule a free visit"
                  : this.state.quiz.quizoffermsg}{" "}
              </div>

              <a
                className="btn m-t-sm result-button"
                href={`http://${
                  this.state.quiz == null
                    ? "www.socialmbuzz.com"
                    : this.state.quiz.quizofferbtnlink
                }`}
                target="_blank"
                ref={(el) => {
                  if (el) {
                    el.style.setProperty(
                      "background-color",
                      button_color ? button_color.hex : "",
                      "important"
                    );
                    el.style.setProperty("border", "0", "important");
                    el.style.setProperty(
                      "color",
                      button_color_text && button_color_text.hex
                        ? button_color_text.hex
                        : this.state.quiz &&
                          this.state.quiz.welcome_message_color
                        ? this.state.quiz.welcome_message_color
                        : "",
                      "important"
                    );
                  }
                }}
              >
                {this.state.quiz == null ||
                this.state.quiz.quizofferbtntxt == null ||
                this.state.quiz.quizofferbtntxt == ""
                  ? "Schedule Now"
                  : this.state.quiz.quizofferbtntxt}
              </a>

              <div
                className="qzwcmsg text-center"
                style={{
                  fontSize: 16,
                  wordWrap: "break-word",
                }}
              >
                {this.state.quiz == null
                  ? "Sample Thank You Message"
                  : this.state.quiz.enable_social_sharing_text}{" "}
              </div>
              {this.state.quiz.is_enable_social_media?<div className="col-md-12 m-t-md">
                  <div className="col-md-1 col-md-offset-3">
                    <FacebookShareButton url={shareUrl} quote="">
                      <FacebookIcon size={shareBtnSize} round />
                    </FacebookShareButton>
                  </div>
                  <div className="col-md-1">
                    <TwitterShareButton url={shareUrl} quote="">
                      <TwitterIcon size={shareBtnSize} round />
                    </TwitterShareButton>
                  </div>
                  <div className="col-md-1">
                    <LinkedinShareButton
                      url={shareUrl}
                      quote=""
                      windowWidth={750}
                      windowHeight={600}
                    >
                      <LinkedinIcon size={shareBtnSize} round />
                    </LinkedinShareButton>
                  </div>
                  <div className="col-md-1">
                    <WhatsappShareButton
                      url={shareUrl}
                      quote=""
                      seperator="::"
                    >
                      <WhatsappIcon size={shareBtnSize} round />
                    </WhatsappShareButton>
                  </div>
                  <div className="col-md-1">
                    <EmailShareButton
                      url={shareUrl}
                      subject=""
                      body="email body"
                    >
                      <EmailIcon size={shareBtnSize} round />
                    </EmailShareButton>
                  </div>
                </div>:null}
              <div
                className="m-t-md qzwcmsg"
                style={{
                  fontSize: "medium",
                  wordWrap: "break-word",
                }}
              >
                {this.state.quiz == null
                  ? "Sample Thank You Message"
                  : this.state.quiz.quizthankyoumsg}{" "}
              </div>
              <div className="col-md-12">
                <a
                  className="btn m-t-sm result-button"
                  ref={(el2) => {
                    if (el2) {
                      el2.style.setProperty(
                        "background-color",
                        button_color
                          ? button_color.hex
                          : "",
                        "important"
                      );
                      el2.style.setProperty("border", "0", "important");
                      el2.style.setProperty(
                        "color",
                        button_color_text ? button_color_text.hex : "",
                        "important"
                      );
                    }
                  }}
                >
                  {this.state.quiz.retake_this_quiz_text
                    ? this.state.quiz.retake_this_quiz_text
                    : "Retake This Quiz"}
                </a>
                
              </div>
              <br />
            </div>
            

            <div className="row">
              
          </div>
          </div>
        );

        break;
    }
    return (
      <div>
        {this.state.quiz.theme_type == 1 ? (
          <div>
            <QuizeThemeFirst
              user={this.state.user}
              bgimg={
                this.state.quiz == null ? null : this.state.quiz.backgroundimg
              }
              is_company_logo={this.state.quiz.is_company_logo}
              header_logo={this.state.quiz.companylogo}
              quiz_title={this.state.quiz.title}
              quiz_footer={this.state.quiz.quizfootermsg}
              content={content}
              is_enable_quiz_title={this.state.quiz.is_enable_quiz_title}
              header_bg={this.props.header_bg}
              header_text={this.props.header_text}
              header_content_bg={this.props.header_content_bg}
              header_content_text={this.props.header_content_text}
              button_color={this.props.button_color}
              footer_bg={this.props.footer_bg}
              footer_text_color={this.props.footer_text_color}
              theme_color_code={
                this.state.theme_color != null ||
                this.state.theme_color != "undefined"
                  ? this.state.quiz.theme_color
                  : ""
              }
              theme_color={
                this.state.quiz == null || this.state.quiz.theme == null
                  ? "theme1"
                  : this.state.quiz.theme
              }
            ></QuizeThemeFirst>
          </div>
        ) : this.state.quiz.theme_type == 2 ? (
          <div>
            <QuizeThemeSecond
              user={this.state.user}
              bgimg={
                this.state.quiz == null ? null : this.state.quiz.backgroundimg
              }
              header_logo={this.state.quiz.companylogo}
              is_company_logo={this.state.quiz.is_company_logo}
              quiz_title={this.state.quiz.title}
              quiz_footer={this.state.quiz.quizfootermsg}
              is_enable_quiz_title={this.state.quiz.is_enable_quiz_title}
              theme_color={
                this.state.quiz == null || this.state.quiz.theme == null
                  ? "theme2"
                  : this.state.quiz.theme
              }
              content={content}
              header_bg={this.props.header_bg}
              header_text={this.props.header_text}
              header_content_bg={this.props.header_content_bg}
              header_content_text={this.props.header_content_text}
              button_color={this.props.button_color}
              footer_bg={this.props.footer_bg}
              footer_text_color={this.props.footer_text_color}
              theme_color_code={
                this.state.theme_color != null ||
                this.state.theme_color != "undefined"
                  ? this.state.quiz.theme_color
                  : ""
              }
            ></QuizeThemeSecond>
          </div>
        ) : this.state.quiz.theme_type == "" ? (
          <div className="col-md-12">
            <div
              className="Sign-In-Label"
              style={{ marginTop: 0, paddingTop: 3, fontSize: 16 }}
            ></div>
            {/* <div className={`panel panel-blur animated slideIn ${this.state.quiz.theme}`}> */}
            <div
              className={`panel panel-blur animated slideIn ${
                this.state.quiz == null || this.state.quiz.theme == null
                  ? "theme1"
                  : this.state.quiz.theme
              }`}
              style={{ marginTop: 10 }}
            >
              {this.renderQuizPreviewHeader()}
              {content}
              {this.renderQuizPreviewFooter()}
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}


